import { onLocaleChanged } from 'owa-localize';
import { orchestrator } from 'satcheljs';
import changeNotesLanguage from '../actions/changeLanguage';

orchestrator(onLocaleChanged, actionMessage => {
    changeNotesLanguage(actionMessage.locale);
});
